import s from './style.module.scss';
import { useCallback, useState } from 'react';
// import useStatusBarHeight from '@/hooks/useStatusBarHeight';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

const ANSWER_KEYS = {
  DUET_QUESTIONNAIRE_Q2_A1: 'feedback_app1',
  DUET_QUESTIONNAIRE_Q2_A2: 'feedback_app2',
  DUET_QUESTIONNAIRE_Q2_A3: 'feedback_app3',
  DUET_QUESTIONNAIRE_Q2_A4: 'feedback_app4',
  DUET_QUESTIONNAIRE_Q2_A5: 'feedback_app5',
};
export default function Questionnaire(props) {
  const { setStep, setAnswerDic, setShowConfirm, answerDic } = props;
  const { t } = useTranslation();

  const [answer, setAnswer] = useState();
  const [inputActive, setInputActive] = useState(false);
  const handleInputChange = useCallback((e) => {
    setAnswerDic(Object.assign(answerDic, { q2: e.target.value }));
    setInputActive(true);
    setAnswer(e.target.value);
    if (e.target.value.length > 0) {
      setShowConfirm(true);
    } else {
      setShowConfirm(false);
    }
  }, []);

  const handleAnswer = useCallback(
    (key) => {
      setInputActive(false);
      setAnswer(ANSWER_KEYS[key]);
      setAnswerDic(Object.assign(answerDic, { q2: ANSWER_KEYS[key] }));
      setTimeout(() => setStep(3), 300);
    },
    [answerDic]
  );

  return (
    <div className={s.root}>
      <div className={s.title}>{t('DUET_QUESTIONNAIRE_Q2')}</div>
      <div className={s.answerWrapper}>
        {Object.keys(ANSWER_KEYS).map((key) => (
          <div
            onClick={() => handleAnswer(key)}
            key={key}
            className={cx(s.answerItem, { [s.active]: answer === ANSWER_KEYS[key] && !inputActive })}
          >
            {t(key)}
          </div>
        ))}
        <input
          type="text"
          value={inputActive ? answer : undefined} // 将输入框的值绑定到组件的状态
          onChange={handleInputChange}
          className={cx(s.answerItem, s.input)}
          placeholder={t('DUET_QUESTIONNAIRE_Q2_ENTER')}
        />
      </div>
    </div>
  );
}
